import React from 'react';
import { iconsEnabled } from '../../../../Helpers/iconHelper';

// The setup Set Up starts from, on the card of a project without automatic invoicing, made to stand out: a setup like
// the project's latest invoice. The business knows it as the AI suggestion; Bravo works it out by rules, as the
// pre-fill from that invoice (InvoiceAutomationSetupModelTools.CreatePrefilledResource).
export default function InvoiceAutomationSuggestion({ invoiceId = null }) {
  return (
    <div className='iauto-suggestion'>
      <div className='iauto-suggestion-badge'>
        {iconsEnabled() && (
          <i
            className='fa-solid fa-wand-magic-sparkles'
            aria-hidden='true'
          />
        )}
        AI suggestion
      </div>
      <p>
        Bravo studied this project&apos;s latest invoice, <strong>{invoiceId}</strong>, and suggests making each
        month&apos;s invoice like it: the same bill-to contact, currency, payment terms, PO number and invoice form.
        <strong> Set Up</strong> opens the suggestion for you to check before anything is saved, each value taken from
        the invoice marked.
      </p>
    </div>
  );
}
